module.exports = __webpack_public_path__ + "static/FilmReel-0b71a66f60868aa0a09e7ec3fe3e244f.svg";